module.exports = __webpack_public_path__ + "static/img/science3.629b4d47.png";